import IconCrowd from 'assets/icons/IconCrowd'
import IconEarth from 'assets/icons/IconEarth'
import IconElectricity from 'assets/icons/IconElectricity'
import IconFood from 'assets/icons/IconFood'
import IconTarget from 'assets/icons/IconTarget'
import Carousel from 'base-components/Carousel'
import React, { useState } from 'react'
import { Slide } from 'utils/getData'
import ImageGalleryModal from './ImageGalleryModal'

interface SlideItemDataProps {
  id: string
  slide: Slide
}

const SlideItemData: React.FC<SlideItemDataProps> = ({ slide, id }) => {
  const [selectedImage, setSelectedImage] = useState<string>('')
  const handleCloseImageGallery = () => setSelectedImage('')

  return (
    <div className='relative flex flex-col justify-between max-w-[600px]'>
      <ImageGalleryModal
        open={Boolean(selectedImage)}
        images={slide.images}
        defaultImage={selectedImage}
        onClose={handleCloseImageGallery}
      />
      <div className='bg-black h-[200px] flex justify-center items-center'>
        <div className='bg-red'>
          <Carousel images={slide.images} onImageClick={setSelectedImage} id={id} />
        </div>
      </div>
      <div className='p-4 my-4'>
        <h1>{slide.title}</h1>
        {slide?.properties && (
          <div className='my-4 text-gray-500 text-sm space-y-1'>
            <div className='flex flex-row items-center border-b-2 border-gray-50 py-2'>
              <IconCrowd className='mr-2 text-primary-500' /> {slide.properties.audienceCapacity}
            </div>
            <div className='flex flex-row items-center border-b-2 border-gray-50 py-2'>
              <IconTarget className='mr-2 text-primary-500' /> {slide.properties.purpose.join(', ')}
            </div>
            {slide.properties?.hasElectricity !== undefined && (
              <div className='flex flex-row items-center border-b-2 border-gray-50 py-2'>
                <IconElectricity className='mr-2 text-primary-500' />
                {slide.properties?.hasElectricity ? 'El finns' : 'El saknas'}
              </div>
            )}
            {slide.properties?.hasRestaurantOrBar !== undefined && (
              <div className='flex flex-row items-center border-b-2 border-gray-50 py-2'>
                <IconFood className='mr-2 text-primary-500' />
                {slide.properties?.hasRestaurantOrBar ? 'Mat eller bar finns' : 'Mat och bar saknas'}
              </div>
            )}
            <div className='flex flex-row items-center border-b-2 border-gray-50 py-2'>
              <IconEarth className='mr-2 text-primary-500' />{' '}
              <a href={slide.properties.website} target='_blank' rel='noreferrer'>
                Hemsida
              </a>
            </div>
          </div>
        )}
        <p className='text-sm'>{slide.description}</p>
      </div>
    </div>
  )
}

export default SlideItemData
